import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL, CURRENCY_NOTE } from './CtaButton';
import { trackCheckoutStart } from '../lib/metaPixel';

/**
 * Discreet mobile-only checkout bar. Appears once the hero CTA has scrolled
 * out of view and hides again whenever another CTA is on screen, so two
 * buttons never compete.
 */
export function StickyCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero-cta');
    const offer = document.getElementById('offer');
    if (!hero) return;
    const state = {
      heroVisible: true,
      offerVisible: false
    };
    const sync = () => setIsVisible(!state.heroVisible && !state.offerVisible);
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) state.heroVisible = entry.isIntersecting;
        if (entry.target === offer) state.offerVisible = entry.isIntersecting;
      });
      sync();
    }, {
      rootMargin: '-8% 0px -8% 0px'
    });
    observer.observe(hero);
    if (offer) observer.observe(offer);
    return () => observer.disconnect();
  }, []);
  return <div aria-hidden={!isVisible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-brand-charcoal/10 bg-brand-white/95 px-4 pb-3 pt-2.5 backdrop-blur-sm transition-opacity duration-200 ease-out md:hidden ${isVisible ? 'opacity-100' : 'pointer-events-none opacity-0'}`} data-id="element-25" data-mp="24y8qx9h7p6o">
      <p className="mb-2 text-center font-body text-[10px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-26" data-mp="lus7xweit6kx">
        {CURRENCY_NOTE}
      </p>
      <a href={CHECKOUT_URL} tabIndex={isVisible ? 0 : -1} onClick={trackCheckoutStart} className="flex w-full items-center justify-center gap-2 rounded-[11px] bg-brand-charcoal px-5 py-3.5 font-body text-[13px] font-semibold uppercase tracking-[0.08em] text-brand-white transition-colors duration-200 ease-out hover:bg-[#1d292b] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-charcoal focus-visible:ring-offset-2" data-id="element-27" data-mp="zt8ffpk7j144">
        Get Instant Access — 23 USD
        <span aria-hidden="true" className="text-base font-normal" data-id="element-28" data-mp="15jbbi6mv68r2">
          →
        </span>
      </a>
    </div>;
}